import { createSlice } from "@reduxjs/toolkit";
import { fetchLevelSubjectWiseQuestion,fetchAllQuestions } from "../features/trainerAsync";

const initialState = {
  greet: "Hi",
  currentStep: 0,
  mode: "random",
  newtestFormData: {
    testType: null,
    testTitle: "",
    level: "",
    exam: "",
    school: "",
    term: "",
    year: "",
    testDuration: 15,
    OrganisationName: null,
    testSubject: null,
    testQuestions: [],
  },
  questionsAvailablebasedonSubject: [],
};

const newTestSlice = createSlice({
  name: "test",
  initialState,
  reducers: {
    changeActiveStep(state, action) {
      state.currentStep = action.payload;
    },
    changeBasicNewTestDetails(state, action) {
      Object.assign(state.newtestFormData, action.payload);
    },
    fetchQuestionsBasedOnSubject(state, action) {
      state.questionsAvailablebasedonSubject = action.payload;
    },
    addQuestionToQuestionQueue(state, action) {
      state.newtestFormData.testQuestions = action.payload;
    },
    removeQuestionFromMainQueue(state, action) {
      state.questionsAvailablebasedonSubject = action.payload;
    },
    changeModeQuestionSelect(state, action) {
      state.mode = action.payload;
    },
  },
    extraReducers: (builder) => {
    builder.addCase(fetchLevelSubjectWiseQuestion.fulfilled, (state, action) => {
      state.questionsAvailablebasedonSubject = action.payload;
    });
    builder.addCase(fetchAllQuestions.fulfilled, (state, action) => {
      state.questionsAvailablebasedonSubject = action.payload;
    })
    // add any other async logic
  }
});

export const {
  changeActiveStep,
  changeBasicNewTestDetails,
  fetchQuestionsBasedOnSubject,
  addQuestionToQuestionQueue,
  removeQuestionFromMainQueue,
  changeModeQuestionSelect,
} = newTestSlice.actions;

export default newTestSlice.reducer;
